module.exports = __webpack_public_path__ + "img/ellipsis-icon.f67941f5.svg";